import { CompanyAttributes, PaymentBrandSalesOfficeAccountingAttributes, PaymentMethodsAttributes, PaymentSalesOfficeAccountingAttributes, PaymentTypeAttributes, SubRouteAttributes } from '@albatrosdeveloper/ave-models-package';
import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { PaymentTypeService } from './payment-type.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IAPIListResult, IPaginationResult, IRequestResult } from 'app/common/interfaces';
import { ICreatePaymentType } from './interfaces/create-payment-type.interface';
import { IUpdatePaymentType } from './interfaces/update-payment-type.interface';
import { MatInputModule } from '@angular/material/input';
import { CompanyService } from '../../configuration/company/company.service.service';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { PaymentMethodService } from '../payment-method/payment-method.service';
import { ReplaySubject, Subject, Subscription, take, takeUntil } from 'rxjs';
import { SubRouteService } from '../../routing/sub-routes/sub-route.service';
import { getCode } from 'app/utils/method';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { RouteGroupService } from '../../routing/route-group/route-group.service';
import RouteGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity';
import { MatTabsModule } from '@angular/material/tabs';
import { PaymentBrandComponent } from './payment-brands/payment-brand.component';
import { PaymentBrandService } from './payment-brands/payment-brand.service';
import PaymentBrandAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/payment-masters/payment-type/payment-brands/payment-brands.entity';
import { DeleteConfirmationComponent } from '../../business-partners/business-partner/delete-modal/delete-modal.component';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { FinanceFiltersComponent } from '../../filters/finance-filters/finance-filters.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { FormSectionComponent } from 'app/shared/components/form-ui/form-section/form-section.component';
import { SalesOfficeService } from '../../configuration/sales-office/sales-office.service';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import { SalesOfficesFormComponent } from '../account-sales/account-sales.component';
import { PaymentBrandSalesOfficeService } from './payment-brands/payment-brand-sales.service';
import { PaymentTypeSalesOfficeService } from './payment-type-sales.service';
import { DialogDataAccountSalesBase } from '../account-sales/interfaces/account-sales.interface';

@Component({
  selector: 'app-payment-type',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggle,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    NgxMatSelectSearchModule,
    MatTabsModule,
    FilterComponent,
    FinanceFiltersComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective,
    FormSectionComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  templateUrl: './payment-type.component.html',
  styleUrl: './payment-type.component.scss'
})
export class PaymentTypeComponent implements OnDestroy{
  getCode = getCode;
  displayedColumns: string[] = [
    "description",
    "company",
    "requiresPhoto",
    "statusId",
    "action"
  ];

  displayedColumnsBrand: string[] = ["name", "accounting", "statusId", "actions"];

  dataSource = new MatTableDataSource<PaymentTypeAttributes>([]);

  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof PaymentTypeAttributes = "name";
  sortDirection: "ASC" | "DESC" = "ASC";
  showFields: boolean = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  companyList: CompanyAttributes[] = []
  companyFilterList: CompanyAttributes[] = []

  paymentMethodList: PaymentMethodsAttributes[] = []
  paymentMethodFilterList: PaymentMethodsAttributes[] = []

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  currentUpdatePaymentType: IUpdatePaymentType | undefined;

  routeList: SubRouteAttributes[] = [];
  /** control for the selected masterUser for multi-selection */
  public routeMultiCtrl: FormControl<any[]> =
    new FormControl<any[]>([]);

  public routeMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of routeArea filtered by search keyword */
  public filteredRoute: ReplaySubject<SubRouteAttributes[]> =
    new ReplaySubject<SubRouteAttributes[]>(1);

  /** local copy of filtered routeArea to help set the toggle all checkbox state */
  protected filteredRouteCache: SubRouteAttributes[] = [];



  routeGroupList: RouteGroupAttributes[] = [];
  /** control for the selected masterUser for multi-selection */
  public routeGroupMultiCtrl: FormControl<any[]> =
    new FormControl<any[]>([]);

  public routeGroupMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of routeArea filtered by search keyword */
  public filteredGroupRoute: ReplaySubject<RouteGroupAttributes[]> =
    new ReplaySubject<RouteGroupAttributes[]>(1);

  /** local copy of filtered routeArea to help set the toggle all checkbox state */
  protected filteredGroupRouteCache: RouteGroupAttributes[] = [];


  protected _onDestroy = new Subject<void>();

  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;

  //BUSCADOR
  searchSubscription: Subscription;

  form: FormGroup
  selectedStatuses: number [] = [];

  // Lazy loading flags
  loadFiltersData = false;

  //#region Config Sales Office
  createForm: FormGroup;
  editForm: FormGroup;
  //#endregion

  constructor(
    private paymentTypeService: PaymentTypeService,
    private paymentBrandService: PaymentBrandService,
    private readonly companyService: CompanyService,
    private readonly paymentMethodService: PaymentMethodService,
    private subRouteService: SubRouteService,
    private routeGroupService: RouteGroupService,
    private readonly searchService: SearchService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly paymentTypeSalesOfficeService: PaymentTypeSalesOfficeService,
    private readonly paymentBrandSalesOfficeService: PaymentBrandSalesOfficeService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      companyId:[],
      paymentMethodId: []
    });
   }

   clearFilters(): void {
    this.selectedStatuses = [];
    this.form.reset({
      paymentModelId: []
    });
    this.getList();
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.getList();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getList()
  }
    
  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.getList()
      });
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    if (!this.paymentMethodList.length) {
      this.getAllPaymentMethod();
    }
  }

  getList(): void {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    const dataFilter: IFilters = {
      companyId: this.form.get("companyId").value,
      paymentMethodId: this.form.get("paymentMethodId").value,
      status: this.selectedStatuses
    }

    this.paymentTypeService.getAllPaginatePaymentType(options, dataFilter).subscribe({
      next: (res: IPaginationResult<PaymentTypeAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener tipos de pago", "Cerrar", { duration: 5000 });
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction
    this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getList()
  }

  buildCreateForm(): void {
    this.createForm = this.fb.group({
      code: ['', Validators.required],
      name: ['', Validators.required],
      description: ['', Validators.required],
      selectedPayment: [null, Validators.required],
      companyId: ['', Validators.required],
      bankComission: [null],
      taxRetainment: [null],
      paymentMethod: "",
      paymentMethodCode: "",
      accountingAccount: [''],
      costCenter: [''],
      accountingKey: [''],
      appliesOverpayment: [false],
      applyToSubRouteGroup: [true],
      applyToAllSubRoutes: [true],
      applyToTheseSubRouteIds: [[]],
      applyToTheseSubRouteGroup: [[]],
    });
  }

  onToggleApplyToAllRoutes() {
    const applyToAll = this.createForm.get('applyToAllSubRoutes')?.value;
    if (applyToAll) {
      this.routeMultiCtrl.reset();
      // this.routeMultiCtrl.disable();
    } else {
      this.routeMultiCtrl.enable();
    }
  }

  onToggleApplyToAllRoutesUpdate() {
    if (this.currentUpdatePaymentType.applyToAllSubRoutes) {
      // this.routeMultiCtrl.reset();
      this.routeMultiCtrl.disable();
    } else {
      this.routeMultiCtrl.enable();
    }
  }

  onToggleApplyToGroupRoutes() {
    const applyToGroup = this.createForm.get('applyToSubRouteGroup')?.value;
    if (applyToGroup) {
      this.routeGroupMultiCtrl.disable();
    } else {
      this.routeGroupMultiCtrl.enable();
      this.routeMultiCtrl.enable();
    }
  }

  onToggleApplyToGroupRoutesUpdate() {
    if (this.currentUpdatePaymentType.applyToSubRouteGroup) {
      this.routeGroupMultiCtrl.enable();
      this.routeMultiCtrl.reset();
      this.routeMultiCtrl.disable();
    } else {
      this.routeGroupMultiCtrl.enable();
      this.routeMultiCtrl.enable();
    }
  }


  private fetchRoute(): void {
    this.subRouteService.findToComboBoxByGroup(this.routeGroupMultiCtrl.value?.map((rou: RouteGroupAttributes) => rou?._id?.toString())).subscribe((res) => {
      this.routeList = res.data;
      this.filteredRoute.next(this.routeList);


      this.filteredRoute.pipe(take(1)).subscribe((routes) => {
        const selectedMaterials = routes.filter((route) =>
          this.currentUpdatePaymentType?.applyToTheseSubRouteIds
            .map((r) => r)
            .includes(route._id.toString())
        );
        this.routeMultiCtrl.setValue(selectedMaterials.map(route => route));
      });

      // listen for search field value changes
      this.routeMultiFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterRouteGroupMulti();
        });
    });
  }

  protected filterRouteGroupMulti() {
    if (!this.routeList) {
      return;
    }
    // get the search keyword
    let search = this.routeMultiFilterCtrl.value;
    if (!search) {
      this.filteredRouteCache = this.routeList;
      this.filteredRoute.next(this.routeList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredRouteCache = this.routeList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredRoute.next(this.filteredRouteCache);
  }


  private fetchGroupRoute(isEditMode: boolean = false): void {
    this.routeGroupService.findToComboBox().subscribe((res) => {
      this.routeGroupList = res.data;
      this.filteredGroupRoute.next(this.routeGroupList);

      if (isEditMode) {
        const selectedIds = this.editForm?.get('applyToTheseSubRouteGroup')?.value ?? [];

        this.filteredGroupRoute.pipe(take(1)).subscribe((routes) => {
          const selectedMaterials = routes.filter(route =>
            selectedIds.includes(route._id.toString())
          );
          this.routeGroupMultiCtrl.setValue(selectedMaterials.map(route => route));
        });
      }

      // listen for search field value changes
      this.routeGroupMultiFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filteredRouteGroupMulti();
        });
    });
  }

  protected filteredRouteGroupMulti() {
    if (!this.routeGroupList) {
      return;
    }
    // get the search keyword
    let search = this.routeGroupMultiFilterCtrl.value;
    if (!search) {
      this.filteredGroupRouteCache = this.routeGroupList;
      this.filteredGroupRoute.next(this.routeGroupList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredGroupRouteCache = this.routeGroupList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredGroupRoute.next(this.filteredGroupRouteCache);
  }

  getAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data;
        this.companyFilterList = this.companyList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.","Cerrar",{ duration: 5000});
      }
    });
  }

  getAllPaymentMethod(): void {
    this.paymentMethodService.findToComboBox().subscribe({
      next: (res: IRequestResult<PaymentMethodsAttributes[]>) => {
        this.paymentMethodList = res.data;
        this.paymentMethodFilterList = this.paymentMethodList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener metodos de pago.","Cerrar",{ duration: 5000});
      }
    })
  }

  changueOptionsPaymentMethod(event) {
    if (!this.paymentMethodList) {
      return;
    }
    let search = event;
    if (!search) {
      this.paymentMethodFilterList = this.paymentMethodList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.paymentMethodFilterList = this.paymentMethodList.filter(item => item.code.toLowerCase().indexOf(search) > -1 || item.name.toLowerCase().indexOf(search) > -1)
  }

  openCreateModal(): void {
    this.buildCreateForm();
    this.getAllCompanies()
    this.getAllPaymentMethod()
    // this.fetchRoute();
    this.fetchGroupRoute();
    this.dialogRefAdd = this.dialog.open(this.addModal, { width: '90%', disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createPaymentType());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  // Rutas
  public onSelectionChangeGroupRoutes(): void {
    this.fetchRoute();
  }

  buildEditForm(data: IUpdatePaymentType): void {
    this.editForm = this.fb.group({
      _id: [data._id],
      name: [data.name, Validators.required],
      code: [data.code],
      description: [data.description],
      companyId: [data.companyId],
      selectedPayment: [data.selectedPayment],
      bankComission: [data.bankComission],
      taxRetainment: [data.taxRetainment],
      costCenter: [data.costCenter],
      accountingAccount: [data.accountingAccount],
      accountingKey: [data.accountingKey],
      appliesOverpayment: [data.appliesOverpayment ?? false],
      applyToSubRouteGroup: [data.applyToSubRouteGroup ?? false],
      applyToAllSubRoutes: [data.applyToAllSubRoutes ?? false],
      salesOffices: this.fb.array([]),
    });
  }

  openEditModal(paymentType: PaymentTypeAttributes): void {
    this.getAllCompanies()
    this.getAllPaymentMethod()
    // this.fetchRoute();
    this.fetchGroupRoute()
    this.currentUpdatePaymentType = {
      ...paymentType,
      companyId: paymentType.company ? paymentType.company._id.toString() : "",
      selectedPayment: {
        name: paymentType.paymentMethod,
        code: paymentType.paymentMethodCode
      }
    };
    this.currentUpdatePaymentType.applyToAllSubRoutes ??= true;
    this.currentUpdatePaymentType.applyToSubRouteGroup ??= true;
    this.buildEditForm(this.currentUpdatePaymentType);
    this.dialogRefEdit = this.dialog.open(this.editModal, { width: '90%', disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updatePaymentType(paymentType._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  comparePaymentMethods(a: any, b: any): boolean {
    if (!a || !b) return false;
    return (a.code && b.code) ? a.code === b.code : a.name === b.name;
  }

  createPaymentType(): void {
    if (this.createForm.invalid) return;

    const formValues = this.createForm.value;

    const payload: ICreatePaymentType = {
      ...formValues,
      paymentMethod: formValues.selectedPayment.name,
      paymentMethodCode: formValues.selectedPayment.code,
      applyToTheseSubRouteIds: this.routeMultiCtrl.value?.map((rou: SubRouteAttributes) => rou?._id?.toString()) ?? [],
      applyToTheseSubRouteGroup: this.routeGroupMultiCtrl.value?.map((rou: RouteGroupAttributes) => rou?._id?.toString()) ?? []
    };

    if (!this.shouldShowPaymentFields(formValues.selectedPayment?.code)) {
      payload.bankComission = 0;
      payload.taxRetainment = 0;
      payload.accountingAccount = '0';
      payload.costCenter = '';
      payload.accountingKey = '';
    }

    this.paymentTypeService.create(payload).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.getList();
        this.dialogRefAdd.close();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updatePaymentType(id: string): void {
    if (this.editForm.valid) {
      const formValue = this.editForm.value;
      const updatedPaymentType: IUpdatePaymentType = {
        ...this.currentUpdatePaymentType,
        paymentMethod: formValue.selectedPayment?.name,
        paymentMethodCode: formValue.selectedPayment?.code,
        applyToTheseSubRouteIds: this.routeMultiCtrl.value?.map((rou: SubRouteAttributes) => rou?._id?.toString()) ?? undefined,
        applyToTheseSubRouteGroup: this.routeGroupMultiCtrl.value?.map((rou: RouteGroupAttributes) => rou?._id?.toString()) ?? undefined,
        applyToSubRouteGroup: formValue.applyToSubRouteGroup,
        applyToAllSubRoutes: formValue.applyToAllSubRoutes
      };

      this.paymentTypeService.update(id, updatedPaymentType).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.getList();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, paymentType: PaymentTypeAttributes): void {
    const originalStatusId = paymentType.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedPaymentType = { ...paymentType, statusId: updatedStatusId };

    this.paymentTypeService.update(paymentType._id.toString(), updatedPaymentType).subscribe({
      next: () => {
        this.getList();
      },
      error: () => {
        paymentType.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.getList();
      }
    });
  }

  onRequiresPhotoChange(event: boolean, paymentType: PaymentTypeAttributes): void {
    const originalStatusId = paymentType.requiresPhoto;
    const updatedStatusId = event ? true : false;
    const updatedPaymentType: any = { requiresPhoto: updatedStatusId };

    this.paymentTypeService.update(paymentType._id.toString(), updatedPaymentType).subscribe({
      next: () => {
        this.getList();
      },
      error: () => {
        paymentType.requiresPhoto = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.getList();
      }
    });
  }

  openDeleteDialog(paymentType: PaymentTypeAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: paymentType, panelClass: "delete-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.delete(paymentType._id.toString()));
  }

  delete(id: string): void {
    this.paymentTypeService.remove(id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  openPaymentBrand(existingData?: any) {
    const dialogRef = this.dialog.open(PaymentBrandComponent, {
      panelClass: "form-modal",
      data: existingData,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateBrand(result);
        } else {
          this.createBrand(result);
        }
      }
    });
  }
  createBrand(result): void {
    this.paymentBrandService
      .createEmbedded(this.currentUpdatePaymentType._id.toString(), result)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.paymentBrandService
            .getAllPaymentBrand(this.currentUpdatePaymentType._id.toString())
            .subscribe((data) => {
              this.currentUpdatePaymentType.paymentBrands = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updateBrand(result): void {
    this.paymentBrandService
      .updateEmbedded(
        this.currentUpdatePaymentType._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.paymentBrandService
            .getAllPaymentBrand(this.currentUpdatePaymentType._id.toString())
            .subscribe((data) => {
              this.currentUpdatePaymentType.paymentBrands = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  onStatusBrand(event: boolean, item: any): void {
    const originalStatusId = item.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBusinessPartnerChain = { ...item, statusId: updatedStatusId };

    this.paymentBrandService
      .updateEmbedded(
        this.currentUpdatePaymentType._id.toString(),
        item._id.toString(),
        updatedBusinessPartnerChain
      )
      .subscribe({
        next: () => {
          this.paymentBrandService
            .getAllPaymentBrand(this.currentUpdatePaymentType._id.toString())
            .subscribe((data) => {
              this.currentUpdatePaymentType.paymentBrands = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: () => {
          item.statusId = originalStatusId;
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.paymentBrandService
            .getAllPaymentBrand(this.currentUpdatePaymentType._id.toString())
            .subscribe((data) => {
              this.currentUpdatePaymentType.paymentBrands = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
      });
  }

  openDeleteBrand(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteBrand(item));
  }

  deleteBrand(item: any): void {
    this.paymentBrandService
      .deleteEmbedded(
        this.currentUpdatePaymentType._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.snackBar.open("Cadena de distribución eliminada con éxito", "Cerrar", {
          duration: 3000,
        });
        this.paymentBrandService
          .getAllPaymentBrand(this.currentUpdatePaymentType._id.toString())
          .subscribe((data) => {
            this.currentUpdatePaymentType.paymentBrands = data?.data;
            this.paginator.length = this.totalItems;
          });
      });
  }

  openBrandSaleOffice(brand: PaymentBrandAttributes){
    this.dialog.open(SalesOfficesFormComponent, {
      width: '90%',
      height: '90%',
      data: {
        title: 'Determinación de Cuentas',
        crudService: this.paymentBrandSalesOfficeService,
        fatherId: this.currentUpdatePaymentType._id,
        element: brand,
        multiMode: true
      } as DialogDataAccountSalesBase<PaymentBrandSalesOfficeAccountingAttributes>
    });
  }

  shouldShowPaymentFields(paymentCode: string): boolean {
    const excludedPaymentCodes = ['MP00002', 'MP00007', 'MP00008'];
    return !excludedPaymentCodes.includes(paymentCode);
  }

  onPaymentMethodChange(payment: any) {
    this.showFields = this.shouldShowPaymentFields(payment.code);
  }

  //#region Config Sales Office
  openPaymentSaleOffice(element: PaymentTypeAttributes){
    this.dialog.open(SalesOfficesFormComponent, {
      width: '90%',
      data: {
        title: 'Determinación de Cuentas',
        crudService: this.paymentTypeSalesOfficeService,
        fatherId: null,
        element: element
      } as DialogDataAccountSalesBase<PaymentSalesOfficeAccountingAttributes>
    });
  }
  //#endregion

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
